<template lang="pug">
	//- Панель под полем ввода: чаты, выбор модели, использованный контекст, выбор файлов, реагирование на ошибки превью, голосовой ввод и отправка
	.ai-chat-controls
		.ai-chat-controls-left
			//- Список чатов версии, в самом верху меню - закреплённая кнопка создания нового чата
			.ai-chat-control.chats-button(v-on:click="openChatsDropdown($event)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Chats history'}")
				i.fa.fa-bars
				span Chats
			InputSelect.ai-chat-model-select(v-on:change="$emit('set-model', $event)" :default="modelCodename" :value="modelCodename" :values="modelItems" :options="{editable: false, dropdownWidth: 260, displayedValueTransform: v => textModelsByCodename[v]?.title || ''}" theme="dark-medium")
			.ai-chat-context-used {{contextUsedPercent}}% context used
		.ai-chat-controls-right
			AIAgentVoiceControls(:chat="chat" :model-codename="modelCodename")
				//- Выбор файлов для отправки в чат обычным диалогом (несколько файлов, в том числе zip и html)
				button.btn.btn-sm.voice-button.attachments-button(type="button" :disabled="attachmentsBusy" v-on:click="openAttachmentsDialog()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: `Attach files (up to ${maxAttachmentFiles}, max ${maxAttachmentsTotalSize} in total). You can also drop files on the chat`}")
					i.fa.fa-paperclip
				input.ai-chat-attachments-input(ref="attachmentsInput" type="file" multiple :accept="attachmentsAccept" v-on:change="onAttachmentsSelected($event)")
				//- Включение / выключение реагирования на ошибки во фрейме превью (для каждой версии, по умолчанию включено)
				button.btn.btn-sm.voice-button.preview-errors-button(type="button" :class="{active: previewErrorCatching}" v-on:click="$emit('toggle-preview-errors')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: previewErrorCatching ? 'Disable reacting to preview errors' : 'Enable reacting to preview errors'}")
					i.fa.fa-bug
			button.btn.btn-primary.btn-sm.send-button(type="button" :disabled="!sendAvailable" v-on:click="$emit('send')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Send message (Enter)'}")
				i.fa.fa-paper-plane
</template>

<script>
	import { Version } 			from './../../services/Version'
	import { AIAgent } 			from './../../services/AIAgent'
	import { Server } 			from './../../services/Server'

	import InputSelect			from './../Editor/Controls/InputSelect'
	import AIAgentVoiceControls	from './AIAgent.VoiceControls'

	export default {
		name: "AIAgentControls",
		// chats / chat - чаты выбранной версии и текущий чат, messages и prompt - для подсчёта использованного контекста,
		// modelCodename / modelItems / textModelsByCodename - выбранная и доступные текстовые модели,
		// sendAvailable - отправка доступна, attachmentsBusy - файлы разбираются или отправляются, previewErrorCatching - реагирование на ошибки превью включено
		props: ['chats', 'chat', 'messages', 'prompt', 'modelCodename', 'modelItems', 'textModelsByCodename', 'sendAvailable', 'attachmentsBusy', 'previewErrorCatching'],
		components: {
			InputSelect,
			AIAgentVoiceControls
		},
		data() {

			// Ограничения и форматы файлов, отправляемых в чат
			this.attachmentsAccept = AIAgent.getAttachmentsAccept();
			this.maxAttachmentFiles = AIAgent.getMaxAttachmentFiles();
			this.maxAttachmentsTotalSize = AIAgent.formatAttachmentSize(AIAgent.getMaxAttachmentsTotalSize());

			return {};

		},
		computed: {
			// Процент использованного контекста выбранной модели (в байтах)
			contextUsedPercent() {

				if (!this.modelCodename) return 0;

				let modelProps = this.textModelsByCodename[this.modelCodename];
				let maxContext = modelProps?.options?.context || 0;

				if (!maxContext) return 0;

				let totalBytes = 0;

				if (this.messages && this.messages.length) {

					for (let message of this.messages) {

						let type = AIAgent.getMessageType(message);

						// Исключаем чисто локальные служебные сообщения (статистика, ошибки, статус распознавания голоса)
						if (type !== 'stats' && type !== 'voice' && type !== 'error') {

							if (message.message) {

								totalBytes += new Blob([message.message]).size;

							}

						}

					}

				}

				if (this.prompt) {

					totalBytes += new Blob([this.prompt]).size;

				}

				if (totalBytes <= 0) return 0;

				return Math.min(100, Math.ceil((totalBytes / maxContext) * 100));

			}
		},
		methods: {
			openChatsDropdown(e) {

				let items = _.map(this.chats, chat => ({
					title: chat.title,
					titleColor: 'var(--secondary)',
					description: chat.lastMessageDate ? chat.lastMessageDate.toLocaleString() : '',
					icon: chat.id === this.chat?.id ? 'fa-check' : null,
					data: {
						chatId: chat.id
					}
				}));

				Broadcast.call("Show InputSelectDropdown", [e.target.closest('.chats-button'), items, {
					width: 220,
					height: Math.min(items.length * 45, 200),
					align: 'left',
					header: {
						title: 'Chats',
						// Кнопка нового чата в хидере меню - вне прокручиваемого списка, всегда видна при открытии
						button: {
							title: 'New Chat',
							icon: 'fa-plus',
							data: {
								newChat: true
							}
						}
					},
					callback: data => {

						if (data.newChat) return this.newChat();

						let chat = _.find(this.chats, chat => chat.id === data.chatId);

						if (chat) this.$emit('select-chat', chat);

					}
				}]);

			},
			// Сервер создаст чат и сообщит его id событием AI Chat Created - компонент чата сразу переключится на него
			newChat() {

				if (!Version.SelectedVersion) return;

				Server.sendToServer({
					AiChatCreate: {
						versionId: Version.SelectedVersion.id
					}
				});

			},
			openAttachmentsDialog() {

				if (this.$refs.attachmentsInput) this.$refs.attachmentsInput.click();

			},
			onAttachmentsSelected(event) {

				let files = Array.from(event.target.files || []);

				// Чтобы повторный выбор тех же файлов тоже вызвал change
				event.target.value = '';

				this.$emit('attach-files', files);

			}
		}
	}
</script>

<style lang="sass">

	.ai-chat
		.ai-chat-input
			.ai-chat-attachments-input
				display: none

			.ai-chat-controls
				display: flex
				flex-direction: row
				align-items: center
				justify-content: space-between
				margin-top: 8px

				.ai-chat-controls-left
					display: flex
					flex-direction: row
					align-items: center
					gap: 10px
					min-width: 0

				.ai-chat-controls-right
					display: flex
					flex-direction: row
					align-items: center

				.ai-chat-control
					display: flex
					flex-direction: row
					align-items: center
					gap: 6px
					height: 30px
					padding: 0 10px
					font-size: 13px
					white-space: nowrap
					color: #f3f4f5
					background-color: #515b65
					border: 1px solid #23282c
					border-radius: 0.25rem
					cursor: pointer

					&:hover
						border-color: rgba(255, 255, 255, 0.3)
						color: #20a8d8

					&.disabled
						opacity: 0.5
						cursor: default
						pointer-events: none

				.ai-chat-model-select
					.number-input
						width: 180px

						input
							cursor: pointer

				.ai-chat-context-used
					font-size: 12px
					color: #73818f
					white-space: nowrap
					cursor: default

				.send-button
					width: 34px
					height: 30px
					display: flex
					align-items: center
					justify-content: center

				// Переключатель реагирования на ошибки фрейма отделён от кнопки микрофона, кнопка выбора файлов - от переключателя
				.preview-errors-button, .attachments-button
					margin-right: 20px !important

				// Кнопки голосового ввода, выбора файлов и реагирования на ошибки превью
				.voice-button
					width: 34px
					height: 30px
					display: flex
					align-items: center
					justify-content: center
					margin-right: 6px
					color: #f3f4f5
					background-color: #515b65
					border: 1px solid #23282c
					user-select: none
					-webkit-touch-callout: none

					&:hover:not(:disabled)
						border-color: rgba(255, 255, 255, 0.3)
						color: var(--primary)

					&.active:hover:not(:disabled)
						color: var(--dark)

					&:focus
						box-shadow: none

					&:disabled
						opacity: 0.5
						cursor: default

					&.active
						color: #fff
						background-color: #20a8d8
						border-color: #20a8d8

					&.recording
						color: #fff
						background-color: #f86c6b
						border-color: #f86c6b
						animation: ai-chat-voice-pulse 1s ease-in-out infinite

</style>
